export default __webpack_public_path__ + "static/media/happyNewYearImg.3ca4d230.png";